import React from 'react';
import UserStore from 'stores/UserStore';
import { Button, message, Popconfirm } from 'antd';

interface IProps {
    isPrimary: boolean;
    id: number;
    email: string;
    updateData: () => void;
}

const SetPrimary: React.FC<IProps> = props => {
    const handleClick = () => {
        UserStore.setPrimaryMail(props.id)
            .then(() => {
                props.updateData();
            })
            .catch(err => {
                message.error('Error');
            });
    };
    return (
        <>
            <Popconfirm
                title={`This will make ${props.email} be your login Email and the primary recipient for updates`}
                onConfirm={handleClick}
                okText="Confirm"
                cancelText="Cancel"
            >
                {!props?.isPrimary ? (
                    <Button size="small" className="ant-btn-xs">
                        Set Primary
                    </Button>
                ) : null}
            </Popconfirm>
        </>
    );
};

export default SetPrimary;
